module.exports = require('./lib/client/index');



//////////////////
// WEBPACK FOOTER
// ./~/feathers/client.js
// module id = 254
// module chunks = 0